import * as yup from "yup";

export const retailInitValue = {
  business_purpose_loan_flag: "Y",
  customers_loan_has_collateral_flag: "Y",
  customer_id: "",
  gender: "Female",
  date_of_birth: null,
  address: "",
  identification: "",
  historical_rating_rating_date: null,
  historical_rating_rating_id: "",
  historical_rating_rm_id: "",
  historical_rating_branch: "",
  historical_rating_latest_rating: "",
  // facility
  tentative_loan_product_code: null,
  tentative_loan_product: null,
  tentative_loan_amount: "",
  tentative_loan_ccy: "VND",
  tentative_loan_tenor: "",
  contract_id: "",
  payment_frequency: "Monthly",
  interest_rate_type: "Fixed",
  repricing_frequency: "3",
  original_date: null,
  payment_amount_1: "",
  start_date_payment_1: null,
  payment_amount_2: "",
  start_date_payment_2: null,
  total_no_of_payment_1: "",
  total_no_of_payment_2: "",
  collateral_type: null,
  collateral_type_name: null,
  collateral_id: "",
  collateral_currency: "VND",
  collateral_value: "",
  collateral_value_in_local_currency: "",
  collateral_senior_claim_flag: "Y",
  collateral_eligible_cre_rre_flag: "Y",
  eligible_other_irb_collat_flag: "Y",
  eligible_irb_receivables_flag: "Y",
  eligible_guarantee_flag: "Y",
};

export const retailValidationSchema = yup.object().shape({
  business_purpose_loan_flag: yup.string().required("This field is required"),
  customers_loan_has_collateral_flag: yup
    .string()
    .required("This field is required"),
  customer_id: yup.string().required("This field is required"),
  gender: yup.string().required("This field is required"),
  date_of_birth: yup.date().nullable(),
  historical_rating_rating_date: yup.date().nullable(),
  historical_rating_latest_rating: yup
    .string()
    .required("This field is required"),
  tentative_loan_product_code: yup.string().required("This field is required"),
  tentative_loan_product: yup.string().required("This field is required"),
  tentative_loan_amount: yup.string().required("This field is required"),
  tentative_loan_ccy: yup.string().required("This field is required"),
  tentative_loan_tenor: yup.string().required("This field is required"),
  payment_frequency: yup.string().required("This field is required"),
  interest_rate_type: yup.string().required("This field is required"),
  repricing_frequency: yup.string().required("This field is required"),
  original_date: yup.date().nullable(),
  payment_amount_1: yup.string().required("This field is required"),
  start_date_payment_1: yup
    .date()
    .nullable()
    .required("This field is required"),
  total_no_of_payment_1: yup.string().required("This field is required"),
  collateral_type: yup.string().nullable().required("This field is required"),
  collateral_type_name: yup.string().nullable(),
  collateral_currency: yup.string().required("This field is required"),
  collateral_value: yup.string().required("This field is required"),
  collateral_senior_claim_flag: yup.string().required("This field is required"),
  collateral_eligible_cre_rre_flag: yup
    .string()
    .required("This field is required"),
  eligible_other_irb_collat_flag: yup
    .string()
    .required("This field is required"),
  eligible_irb_receivables_flag: yup
    .string()
    .required("This field is required"),
  eligible_guarantee_flag: yup.string().required("This field is required"),
});

export const corInitValue = {
  business_purpose_loan_flag: "Y",
  customers_loan_has_collateral_flag: "Y",
  customer_id: "",
  customer_name: "",
  party_type: "",
  customer_industry: "",
  number_of_employees: "",
  revenue: "",
  total_assets: "",
  date_of_establishment: null,
  address: "",
  business_license_investment_license_number: "",
  tax_code: "",
  financial_statement_date: null,
  historical_rating_rating_date: null,
  historical_rating_rating_id: "",
  historical_rating_rm_id: "",
  historical_rating_branch: "",
  historical_rating_latest_rating: "",

  // facility
  tentative_loan_product_code: null,
  tentative_loan_product: null,
  tentative_loan_amount: "",
  tentative_loan_ccy: "VND",
  tentative_loan_tenor: "",
  contract_id: "",
  payment_frequency: "Monthly",
  interest_rate_type: "Fixed",
  repricing_frequency: "3",
  original_date: null,
  payment_amount_1: "",
  start_date_payment_1: null,
  payment_amount_2: "",
  start_date_payment_2: null,
  total_no_of_payment_1: "",
  total_no_of_payment_2: "",
  collateral_type: null,
  collateral_type_name: null,
  collateral_id: "",
  collateral_currency: "VND",
  collateral_value: "",
  collateral_value_in_local_currency: "",
  collateral_senior_claim_flag: "Y",
  collateral_eligible_cre_rre_flag: "Y",
  eligible_other_irb_collat_flag: "Y",
  eligible_irb_receivables_flag: "Y",
  eligible_guarantee_flag: "Y",
};

export const corValidationSchema = yup.object().shape({
  business_purpose_loan_flag: yup.string().required("This field is required"),
  customers_loan_has_collateral_flag: yup
    .string()
    .required("This field is required"),
  customer_id: yup.string().required("This field is required"),
  customer_industry: yup.string().required("This field is required"),
  number_of_employees: yup.string().required("This field is required"),
  revenue: yup.string().required("This field is required"),
  total_assets: yup.string().required("This field is required"),
  date_of_establishment: yup.date().nullable(),
  financial_statement_date: yup.date().nullable(),
  historical_rating_rating_date: yup.date().nullable(),
  historical_rating_latest_rating: yup
    .string()
    .required("This field is required"),
  tentative_loan_product_code: yup.string().required("This field is required"),
  tentative_loan_product: yup.string().required("This field is required"),
  tentative_loan_amount: yup.string().required("This field is required"),
  tentative_loan_ccy: yup.string().required("This field is required"),
  tentative_loan_tenor: yup.string().required("This field is required"),
  payment_frequency: yup.string().required("This field is required"),
  interest_rate_type: yup.string().required("This field is required"),
  repricing_frequency: yup.string().required("This field is required"),
  original_date: yup.date().nullable(),
  payment_amount_1: yup.string().required("This field is required"),
  start_date_payment_1: yup
    .date()
    .nullable()
    .required("This field is required"),
  total_no_of_payment_1: yup.string().required("This field is required"),
  collateral_type: yup.string().nullable().required("This field is required"),
  collateral_type_name: yup.string().nullable(),
  collateral_currency: yup.string().required("This field is required"),
  collateral_value: yup.string().required("This field is required"),
  collateral_senior_claim_flag: yup.string().required("This field is required"),
  collateral_eligible_cre_rre_flag: yup
    .string()
    .required("This field is required"),
  eligible_other_irb_collat_flag: yup
    .string()
    .required("This field is required"),
  eligible_irb_receivables_flag: yup
    .string()
    .required("This field is required"),
  eligible_guarantee_flag: yup.string().required("This field is required"),
});

const facilityValidation = {
  business_purpose_loan_flag: yup.string().required("This field is required"),
  customers_loan_has_collateral_flag: yup
    .string()
    .required("This field is required"),
  tentative_loan_product_code: yup.string().required("This field is required"),
  tentative_loan_product: yup.string().required("This field is required"),
  tentative_loan_amount: yup.string().required("This field is required"),
  tentative_loan_ccy: yup.string().required("This field is required"),
  tentative_loan_tenor: yup.string().required("This field is required"),
  payment_frequency: yup.string().required("This field is required"),
  interest_rate_type: yup.string().required("This field is required"),
  repricing_frequency: yup.string().required("This field is required"),
  original_date: yup.date().nullable(),
  payment_amount_1: yup.string().required("This field is required"),
  start_date_payment_1: yup
    .date()
    .nullable()
    .required("This field is required"),
  total_no_of_payment_1: yup.string().required("This field is required"),
  collateral_type: yup.string().nullable().required("This field is required"),
  collateral_type_name: yup.string().nullable(),
  collateral_currency: yup.string().required("This field is required"),
  collateral_value: yup.string().required("This field is required"),
  collateral_senior_claim_flag: yup.string().required("This field is required"),
  collateral_eligible_cre_rre_flag: yup
    .string()
    .required("This field is required"),
  eligible_other_irb_collat_flag: yup
    .string()
    .required("This field is required"),
  eligible_irb_receivables_flag: yup
    .string()
    .required("This field is required"),
  eligible_guarantee_flag: yup.string().required("This field is required"),
};

export const corExistingValidationSchema = yup.object().shape({
  customer_id: yup.string().required("This field is required"),
  ...facilityValidation,
});

export const corNewValidationSchema = yup.object().shape({
  customer_id: yup.string().required("This field is required"),
  party_type: yup.string().required("This field is required"),
  financial_statement_date: yup
    .date()
    .nullable()
    .required("This field is required"),
  total_assets: yup.string().required("This field is required"),
  revenue: yup.string().required("This field is required"),
  historical_rating_latest_rating: yup
    .string()
    .required("This field is required"),
  ...facilityValidation,
});



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/initValue.js